// extracted by mini-css-extract-plugin
export default {"container":"PollRequiredInput_container__sf9T9"};